// Bara de jos pe telefon (11 octombrie 2026). Pana azi erau sapte intrari cu emoji pe un rand,
// iar ce nu incapea (Echipa, Biblioteca media, Asistent AI, iesirea din cont) ramanea in
// sidebar, care e display:none sub 768px: de pe telefon nu se ajungea deloc la ele.
// Acum: cel mult patru intrari de zi cu zi, cu „Postare" ca buton central, si „Mai mult",
// care urca o foaie cu tot restul. Aceeasi componenta pentru super_admin, manager si client;
// fiecare interfata ii da listele ei.
import { useState } from 'react';
import { t } from './i18n';

// Iconite de linie (desenul Tabler Icons, licenta MIT), intr-o singura culoare: o iau pe a textului.
const DESENE = {
  acasa: ['M5 12H3l9-9 9 9h-2', 'M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-7', 'M9 21v-6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v6'],
  clienti: ['M5 7a4 4 0 1 0 8 0a4 4 0 1 0-8 0', 'M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2', 'M16 3.13a4 4 0 0 1 0 7.75', 'M21 21v-2a4 4 0 0 0-3-3.85'],
  plus: ['M12 5v14', 'M5 12h14'],
  film: ['M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z', 'M8 4v16', 'M16 4v16', 'M4 8h4', 'M4 16h4', 'M4 12h16', 'M16 8h4', 'M16 16h4'],
  postare: ['M4 20h4l10.5-10.5a2.828 2.828 0 1 0-4-4L4 16v4', 'M13.5 6.5l4 4'],
  aprobari: ['M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0', 'M9 12l2 2l4-4'],
  deAprobat: ['M3 12a9 9 0 1 0 18 0a9 9 0 1 0-18 0', 'M12 7v5l3 3'],
  meniu: ['M4 6h16', 'M4 12h16', 'M4 18h16'],
  inchide: ['M18 6L6 18', 'M6 6l12 12'],
  calendar: ['M4 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z', 'M16 3v4', 'M8 3v4', 'M4 11h16'],
  inbox: ['M3 20l1.3-3.9C1.976 12.663 2.874 8.228 6.4 5.726c3.526-2.501 8.59-2.296 11.845.48c3.255 2.777 3.695 7.266 1.029 10.501C16.608 19.942 11.659 20.922 7.7 19L3 20'],
  echipa: ['M8 7a4 4 0 1 0 8 0a4 4 0 0 0-8 0', 'M16 19h6', 'M19 16v6', 'M6 21v-2a4 4 0 0 1 4-4h4'],
  biblioteca: ['M15 8h.01', 'M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z', 'M3 16l5-5c.928-.893 2.072-.893 3 0l5 5', 'M14 14l1-1c.928-.893 2.072-.893 3 0l3 3'],
  asistent: ['M16.555 3.843l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.643 2.643a2.877 2.877 0 0 1-4.069 0l-.301-.301l-6.558 6.558a2 2 0 0 1-1.239.578L5.172 21H4a1 1 0 0 1-.993-.883L3 20v-1.172a2 2 0 0 1 .467-1.284l.119-.13L4 17h2v-2h2v-2l2.144-2.144l-.301-.301a2.877 2.877 0 0 1 0-4.069l2.643-2.643a2.877 2.877 0 0 1 4.069 0z', 'M15 9h.01'],
  iesire: ['M14 8V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-2', 'M9 12h12l-3-3', 'M18 15l3-3'],
  analize: ['M3 13a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z', 'M15 9a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z', 'M9 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1z'],
  trimise: ['M10 14l11-11', 'M21 3l-6.5 18a.55.55 0 0 1-1 0L10 14l-7-3.5a.55.55 0 0 1 0-1L21 3'],
  conturi: ['M9.785 6L18 14.215l-2.054 2.054a5.81 5.81 0 1 1-8.215-8.215L9.785 6z', 'M4 20l3.5-3.5', 'M15 4l-3.5 3.5', 'M20 9l-3.5 3.5'],
  voce: ['M9 5a3 3 0 0 1 6 0v5a3 3 0 0 1-6 0z', 'M5 10a7 7 0 0 0 14 0', 'M8 21h8', 'M12 17v4'],
  moderare: ['M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1-8.5 15a12 12 0 0 1-8.5-15a12 12 0 0 0 8.5-3', 'M9 12l2 2l4-4'],
  teme: ['M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1-4 0V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12a3 3 0 0 0 3 3h11', 'M8 8h4', 'M8 12h4', 'M8 16h4'],
  raport: ['M14 3v4a1 1 0 0 0 1 1h4', 'M17 21H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7l5 5v11a2 2 0 0 1-2 2z', 'M9 17v-5', 'M12 17v-2', 'M15 17v-3'],
};

export function IconLinie({ nume, marime = 24 }) {
  const linii = DESENE[nume] || DESENE.meniu;
  return (
    <svg width={marime} height={marime} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {linii.map((d, i) => <path key={i} d={d} />)}
    </svg>
  );
}

// Aceleasi desene si in meniul lateral de pe calculator (11 octombrie 2026): intrarile de
// acolo se recunosc dupa id-ul paginii, nu dupa numele desenului.
const DESEN_PE_ID = { client: 'acasa', compositor2: 'postare', aprobare: 'deAprobat', aprobate: 'aprobari' };
export function IconMeniu({ id, marime = 18 }) {
  return <IconLinie nume={DESEN_PE_ID[id] || id} marime={marime} />;
}

// `intrari`: cel mult patru, { id, label, icon, badge, central, activ, onClick }.
// `restul`: randurile din foaie, { id, label, icon, badge, activ, onClick }.
export default function BaraJosMobil({ intrari, restul = [], onLogout = null }) {
  const [deschis, setDeschis] = useState(false);
  const cuInchidere = fn => () => { setDeschis(false); fn(); };
  const bulinaRest = restul.reduce((s, r) => s + (r.badge > 0 ? r.badge : 0), 0);
  const restActiv = restul.some(r => r.activ);

  return (
    <>
      {deschis && (
        <div className="mobile-foaie-fundal" onClick={() => setDeschis(false)}>
          <div className="mobile-foaie" role="menu" onClick={e => e.stopPropagation()}>
            <div className="mobile-foaie-maner" />
            {restul.map(r => (
              <button key={r.id} type="button" role="menuitem" className={`mobile-foaie-rand ${r.activ ? 'activ' : ''}`} onClick={cuInchidere(r.onClick)}>
                <IconLinie nume={r.icon} marime={22} />
                <span>{r.label}</span>
                {r.badge > 0 && <span className="mobile-foaie-bulina">{r.badge}</span>}
              </button>
            ))}
            {onLogout && (
              <button type="button" role="menuitem" className="mobile-foaie-rand iesire" onClick={cuInchidere(onLogout)}>
                <IconLinie nume="iesire" marime={22} />
                <span>{t('sidebar', 'iesiDinCont')}</span>
              </button>
            )}
          </div>
        </div>
      )}
      <div className="mobile-navbar">
        {intrari.map(item => (
          <button key={item.id} type="button" className={`mobile-nav-item ${item.activ && !deschis ? 'activ' : ''} ${item.central ? 'central' : ''}`} onClick={cuInchidere(item.onClick)}>
            {item.badge > 0 && <span className="mobile-nav-badge">{item.badge}</span>}
            <span className="mobile-nav-icon"><IconLinie nume={item.icon} /></span>
            <span className="mobile-nav-label">{item.label}</span>
          </button>
        ))}
        <button type="button" className={`mobile-nav-item ${deschis || restActiv ? 'activ' : ''}`} aria-expanded={deschis} onClick={() => setDeschis(d => !d)}>
          {!deschis && bulinaRest > 0 && <span className="mobile-nav-badge">{bulinaRest}</span>}
          <span className="mobile-nav-icon"><IconLinie nume={deschis ? 'inchide' : 'meniu'} /></span>
          <span className="mobile-nav-label">{deschis ? t('sidebar', 'inchide') : t('sidebar', 'maiMult')}</span>
        </button>
      </div>
    </>
  );
}
